import React from 'react';
import { string, node } from 'prop-types';
import classNames from 'classnames/bind';
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

import Container from 'components/Container';
import IconArrowUp from 'media/icons/arrow-up.icon.svg';
import IconArrowDown from 'media/icons/arrow-down.icon.svg';

import styles from './SearchAccordionItem.module.scss';
const cx = classNames.bind(styles);

const SearchAccordionItem = (props) => {
  const { Panel, Icon, label, uuid } = props;
  return (
    <AccordionItem uuid={uuid}>
      <AccordionItemHeading>
        <AccordionItemButton className={cx('item-mobile')}>
          {Icon}
          {label}
          <span className={cx('icon')}>
            <AccordionItemState>
              {({ expanded }) =>
                expanded ? <IconArrowUp /> : <IconArrowDown />
              }
            </AccordionItemState>
          </span>
        </AccordionItemButton>
      </AccordionItemHeading>
      <div className={cx('white-bg', 'search-tabs-container')}>
        <Container>
          <AccordionItemPanel>{Panel}</AccordionItemPanel>
        </Container>
      </div>
    </AccordionItem>
  );
};

SearchAccordionItem.propTypes = {
  uuid: string.isRequired,
  label: string.isRequired,
  Icon: node.isRequired,
  Panel: node.isRequired,
};

export default SearchAccordionItem;



// WEBPACK FOOTER //
// ./src/components/SearchAccordionItem/SearchAccordionItem.js